import React from 'react';
import { useParams } from 'react-router-dom';

import Section from '@dashboard/components/sections/Section';
import { useDomainNameVerificationQuery } from '@dashboard/generated/wp/administrator';
import { Divider, Grid, Stack } from '@mui/material';

import ApproveButton from './ApproveButton';
import ConfigureMailFromDialog from './ConfigureMailFromDialog';
import DomainNameVerificationProperties from './DomainNameVerificationProperties';
import { RecordsTable } from './RecordsTable';
import RefreshVerificationButton from './RefreshVerificationButton';
import SendConfirmationButton from './SendConfirmationButton';
import SendDoubledDnsEmailButton from './SendDoubledDnsEmailButton';

export default function DomainNameVerificationShow() {
  const id = useParams<{ id: string }>().id!;
  const { data } = useDomainNameVerificationQuery({ variables: { id } });

  const model = data?.DomainNameVerification;
  const button = model && <ApproveButton id={id} status={model.approvalStatus} />;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={8}>
        <Stack spacing={4}>
          <Section title={model?.domainName ?? id} variant="primary">
            <DomainNameVerificationProperties id={id} />
          </Section>
          <Section title="Domain Records" variant="secondary">
            <RecordsTable id={id} />
          </Section>
        </Stack>
      </Grid>
      <Grid item xs={12} lg={4}>
        <Section title="Actions" variant="secondary">
          <Stack spacing={2}>
            {button}
            <Divider />

            <Stack spacing={1.5}>
              <SendConfirmationButton id={id} />
              <SendDoubledDnsEmailButton id={id} />
              <RefreshVerificationButton id={id} />
              <ConfigureMailFromDialog id={id} />
            </Stack>
          </Stack>
        </Section>
      </Grid>
    </Grid>
  );
}
